'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pudoMethod = require('../../transformers/pudoMethod.js');

const cardMap = {
  home_pickup: 'Truck',
  store: 'Store',
  concierge_partnership: 'Store',
  concierge: 'Locate',
  printerless: 'Phone',
  printerless_mail: 'Phone',
  mail: 'Package'
};
const pudoFormatTranslation = pudoOption => {
  const pudoType = pudoMethod.getPudoMethodName(pudoOption);
  const validIcon = Object.keys(cardMap).includes(pudoType);
  const langKeyPrefix = `returnsPudoListItem${pudoType.replace('_', '').toLowerCase()}`;
  return {
    iconType: validIcon ? cardMap[pudoType] : 'Package',
    title: `${langKeyPrefix}Title`,
    subtitle: `${langKeyPrefix}Subtitle`,
    externalUrl: `${langKeyPrefix}Link_text`,
    free: `${langKeyPrefix}Free`
  };
};

exports.pudoFormatTranslation = pudoFormatTranslation;
